import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
import "./page_term.css";

const PageTerm = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <div
      style={{ padding: 20 }}
      id="term"
      className="rounded-lg bg-white p-3 shadow-lg md:p-12 lg:p-8"
    >
      <h1 className="my-4 text-center text-2xl font-bold !text-blue-800">
        ĐIỀU KHOẢN SỬ DỤNG DỊCH VỤ
      </h1>
      <h2 className="center-text mb-4 text-xl font-bold text-gray-800">
        Nền tảng Chuyển đổi Dữ liệu Dịch Vụ Chuyển Âm Website
      </h2>

      <p>Chào mừng Quý khách đến với Dịch Vụ Chuyển Âm Website.</p>

      <p>
        Bằng việc đăng ký tài khoản hoặc sử dụng Dịch vụ của chúng tôi dưới bất
        kỳ hình thức nào, Người Sử Dụng xác nhận đã đọc kỹ, hiểu rõ và đồng ý vô
        điều kiện với toàn bộ nội dung của{" "}
        <strong>Điều Khoản Sử Dụng Dịch Vụ ("Điều Khoản")</strong> này.
      </p>

      <p>
        Đây là một thỏa thuận pháp lý ràng buộc giữa{" "}
        <strong>Người Sử Dụng</strong> (sau đây gọi là "bạn" hoặc "Khách hàng")
        và <strong>Công ty Cổ Phần Tổ Chức Phát Triển Vì Việt Nam</strong>, đơn
        vị chủ quản của nền tảng <strong>Dịch Vụ Chuyển Âm Website</strong> (sau
        đây gọi là "chúng tôi").
      </p>

      <p>
        Điều khoản sử dụng dịch vụ⁠ của chúng tôi chi phối việc sử dụng nền tảng
        Dịch Vụ Chuyển Âm Website của chúng tôi và các dịch vụ khác dành cho
        doanh nghiệp, cá nhân và nhà phát triển.
      </p>

      <p>
        Trong toàn bộ phạm vi lãnh thổ Việt Nam, việc sử dụng Dịch vụ của bạn sẽ
        chịu sự chi phối của các điều khoản này.
      </p>

      <p>
        Chính sách bảo mật của chúng tôi thể hiện chi tiết cách chúng tôi thu
        thập và sử dụng thông tin cá nhân của bạn.
      </p>

      <p>
        Mặc dù chính sách này không nằm trong Điều khoản sử dụng, nhưng vẫn là
        một tài liệu quan trọng mà bạn nên dành thời gian để đọc nhằm hiểu rõ
        cách thức chúng tôi hoạt động và xử lý dữ liệu.
      </p>

      <h2 className="mb-2 mt-6 text-xl font-bold text-gray-800">
        Điều 1: Định Nghĩa
      </h2>
      <p>
        <strong className="mb-1 mt-4 text-lg font-bold text-gray-700">
          1.1. "Dịch Vụ":
        </strong>{" "}
        Là nền tảng công nghệ do Dịch Vụ Chuyển Âm Website cung cấp, cho phép
        Người Sử Dụng tải lên các tệp âm thanh và/hoặc video ("Dữ Liệu Đầu Vào")
        để hệ thống tự động xử lý, phân tích và chuyển đổi thành định dạng văn
        bản ("Văn Bản Đầu Ra").
      </p>
      <p>
        <strong className="mb-1 mt-4 text-lg font-bold text-gray-700">
          1.2. "Tài Khoản":
        </strong>{" "}
        Là tài khoản định danh duy nhất mà Người Sử Dụng đăng ký trên nền tảng
        của chúng tôi để truy cập và sử dụng Dịch Vụ.
      </p>
      <p>
        <strong className="mb-1 mt-4 text-lg font-bold text-gray-700">
          1.3. "Dữ Liệu Người Dùng":
        </strong>{" "}
        Bao gồm Dữ Liệu Đầu Vào, Văn Bản Đầu Ra và tất cả thông tin cá nhân,
        thông tin thanh toán mà bạn cung cấp trong quá trình sử dụng Dịch Vụ.
      </p>

      <h2 className="mb-2 mt-6 text-xl font-bold text-gray-800">
        Điều 2: Đăng ký và truy cập
      </h2>
      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        2.1. Năng lực hành vi và trách nhiệm pháp lý:
      </h3>
      <p>
        Bất kỳ cá nhân hoặc tổ chức nào sử dụng dịch vụ của chúng tôi đều phải
        có đầy đủ năng lực hành vi dân sự theo quy định của pháp luật — tức là
        có khả năng tự mình xác lập và thực hiện các quyền, nghĩa vụ dân sự.
      </p>
      <p>
        Mỗi chủ thể, dù là cá nhân hay tổ chức, đều tự chịu hoàn toàn trách
        nhiệm pháp lý đối với mọi hành vi và giao dịch do mình thực hiện trên
        nền tảng dịch vụ này.
      </p>

      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        2.2. Đăng ký tài khoản:
      </h3>
      <p>Khi đăng ký, bạn phải cung cấp thông tin đầy đủ và chính xác.</p>
      <p>
        Bạn không được chia sẻ thông tin đăng nhập hoặc để người khác sử dụng
        tài khoản của mình.
      </p>
      <p>
        Mọi hoạt động phát sinh từ tài khoản đó đều do bạn chịu trách nhiệm.
      </p>
      <p>
        Nếu bạn tạo tài khoản hoặc sử dụng Dịch vụ thay mặt cho cá nhân hay tổ
        chức khác, bạn cam kết có quyền đại diện và chấp thuận các Điều khoản
        này thay họ.
      </p>

      <h2 className="mb-2 mt-6 text-xl font-bold text-gray-800">
        Điều 3: Phạm Vi và Đặc Tính Dịch Vụ
      </h2>
      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        3.1. Mô Tả Dịch Vụ:
      </h3>
      <p>
        Chúng tôi cung cấp các gói Dịch Vụ đa dạng, từ miễn phí đến trả phí, với
        các giới hạn khác nhau về thời lượng, dung lượng, mức độ ưu tiên xử lý
        và các tính năng nâng cao (như nhận dạng người nói, gắn mốc thời gian,
        v.v.). Chi tiết các gói Dịch Vụ được công bố công khai trên website của
        chúng tôi.
      </p>

      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        3.2. Cơ Sở Cung Cấp "Nguyên Trạng" (As Is):
      </h3>
      <p>
        Dịch Vụ được cung cấp dựa trên nền tảng công nghệ và trí tuệ nhân tạo.
        Do đó, chúng tôi không cam đoan hay bảo đảm rằng Văn Bản Đầu Ra sẽ chính
        xác hoàn toàn. Mức độ chính xác phụ thuộc vào nhiều yếu tố khách quan
        như chất lượng âm thanh, giọng nói, tạp âm, thuật ngữ chuyên ngành,....
        Người Sử Dụng chấp nhận rằng kết quả chỉ mang tính tham khảo và có trách
        nhiệm tự kiểm tra, hiệu đính lại trước khi sử dụng cho các mục đích quan
        trọng, đặc biệt là các mục đích làm bằng chứng pháp lý hoăc các mục đích
        thương mạị.
      </p>

      <h2 className="mb-2 mt-6 text-xl font-bold text-gray-800">
        Điều 4: Quyền và Nghĩa Vụ của Người Sử Dụng
      </h2>
      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        4.1. Nghĩa Vụ Cung Cấp Thông Tin:
      </h3>
      <p>
        Bạn cam kết cung cấp thông tin đăng ký Tài Khoản một cách trung thực,
        chính xác và chịu trách nhiệm cập nhật khi có thay đổi. Mọi quyền lợi và
        thông báo sẽ được gửi đến bạn dựa trên thông tin đã đăng ký.
      </p>

      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        4.2. Nghĩa Vụ Bảo Mật:
      </h3>
      <p>
        Bạn có toàn bộ trách nhiệm trong việc bảo mật thông tin đăng nhập (tên
        người dùng và mật khẩu) của mình. Chúng tôi không chịu trách nhiệm cho
        bất kỳ tổn thất nào phát sinh từ việc bạn làm lộ thông tin hoặc cho phép
        bên thứ ba truy cập vào Tài Khoản của bạn.
      </p>

      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        4.3. Trách Nhiệm về Nội Dung:
      </h3>
      <p>
        Bạn chịu trách nhiệm pháp lý toàn diện đối với mọi Dữ Liệu Đầu Vào mà
        bạn tải lên hệ thống. Bạn cam kết có đầy đủ quyền hợp pháp để sử dụng,
        sao chép và xử lý Dữ Liệu Đầu Vào đó, đồng thời đảm bảo rằng nội dung
        của Dữ Liệu Đầu Vào không vi phạm pháp luật Việt Nam, không xâm phạm
        quyền sở hữu trí tuệ, quyền riêng tư hoặc bất kỳ quyền, lợi ích hợp pháp
        nào của bên thứ ba. Trong trường hợp có vi phạm, bạn hoàn toàn và đơn
        phương chịu trách nhiệm trước pháp luật, và Chúng tôi được miễn trừ khỏi
        mọi trách nhiệm hoặc nghĩa vụ pháp lý phát sinh liên quan.
      </p>
      <p>
        Đối với bất kỳ Dữ Liệu Đầu Vào nào bị xác định là vi phạm theo Bản án
        hoặc Phán quyết có hiệu lực pháp luật, Chúng tôi có quyền (i) từ chối
        tiếp tục xử lý các dữ liệu đó; (ii) xóa vĩnh viễn toàn bộ dữ liệu vi
        phạm trên hệ thống; và/hoặc (iii) vô hiệu hóa tài khoản của người dùng
        đã đăng tải dữ liệu vi phạm.
      </p>

      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        4.4. Giới Hạn Sử Dụng:
      </h3>
      <p>
        Mỗi Tài Khoản được cấp cho một cá nhân hoặc một tổ chức duy nhất. Việc
        chia sẻ tài khoản cho nhiều người dùng không được phép, trừ khi được quy
        định rõ trong gói Dịch Vụ Doanh Nghiệp. Trường hợp tài khoản được cấp
        cho một cá nhân nhưng lại bị sử dụng chung bởi nhiều cá nhân hoặc tổ
        chức khác trái với Điều khoản sử dụng dịch vụ, Chúng tôi có quyền (i)
        khóa và/hoặc thu hồi vĩnh viễn tài khoản; (ii) thu hồi toàn bộ quyền
        truy cập liên quan; và/hoặc (iii) áp dụng chế tài tài chính tương ứng
        với khoản phí mà những người sử dụng trái phép lẽ ra phải thanh toán nếu
        họ trực tiếp sử dụng dịch vụ của Chúng tôi. Mọi thiệt hại phát sinh từ
        hành vi vi phạm này, người sở hữu tài khoản phải hoàn toàn chịu trách
        nhiệm bồi thường.
      </p>

      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        4.5. Bồi thường và giữ vô hại:
      </h3>
      <p>
        Trong phạm vi pháp luật cho phép, nếu bạn là doanh nghiệp hoặc tổ chức,
        bạn đồng ý bồi thường và giữ chúng tôi, các công ty liên kết và nhân
        viên của chúng tôi vô hại trước mọi chi phí, thiệt hại, trách nhiệm pháp
        lý và chi phí (bao gồm cả chi phí luật sư) phát sinh từ các khiếu nại
        của bên thứ ba liên quan đến: Việc bạn sử dụng Dịch vụ hoặc Nội dung;
        Bất kỳ hành vi vi phạm nào đối với các Điều khoản này.
      </p>

      <h2 className="mb-2 mt-6 text-xl font-bold text-gray-800">
        Điều 5: Các Hành Vi Bị Nghiêm Cấm
      </h2>
      <ul>
        <li>
          Cấm sử dụng Dịch Vụ để xử lý Dữ Liệu Đầu Vào có nội dung bất hợp pháp,
          vi phạm thuần phong mỹ tục, mang tính đe dọa, phỉ báng, xâm phạm an
          ninh quốc gia hoặc các nội dung khác bị pháp luật cấm.
        </li>
        <li>
          Cấm sao chép, sửa đổi, dịch ngược, phân tách (decompile) mã nguồn,
          thuật toán hoặc bất kỳ thành phần công nghệ nào cấu thành nên Dịch Vụ
          của chúng tôi cho mục đích thương mại hoặc cạnh tranh.
        </li>
        <li>
          Cấm sử dụng bất kỳ phương thức tự động nào (robot, spider, script) để
          truy cập, trích xuất dữ liệu hoặc gây quá tải cho hạ tầng hệ thống của
          chúng tôi mà không có sự cho phép bằng văn bản.
        </li>
        <li>
          Cấm bán, cho thuê, cấp phép lại hoặc chuyển nhượng quyền sử dụng Dịch
          Vụ hoặc Tài Khoản cho bất kỳ bên thứ ba nào.
        </li>
      </ul>

      <h2 className="mb-2 mt-6 text-xl font-bold text-gray-800">
        Điều 6: Miễn Trừ và Giới Hạn Trách Nhiệm
      </h2>
      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        6.1. Miễn Trừ về Độ Chính Xác:
      </h3>
      <p>
        Chúng tôi được miễn trừ hoàn toàn khỏi mọi trách nhiệm pháp lý liên quan
        đến thiệt hại trực tiếp hoặc gián tiếp phát sinh từ việc Người Sử Dụng
        tin tưởng hoặc dựa vào độ chính xác của Văn Bản Đầu Ra do Dịch Vụ tạo
        ra.
      </p>

      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        6.2. Miễn Trừ về Tính Liên Tục:
      </h3>
      <p>
        Dịch Vụ có thể bị gián đoạn tạm thời để bảo trì, nâng cấp hoặc do các sự
        cố bất khả kháng (sự cố đường truyền, tấn công mạng, v.v.). Chúng tôi sẽ
        nỗ lực thông báo trước và khôi phục trong thời gian sớm nhất, nhưng
        không chịu trách nhiệm bồi thường cho bất kỳ thiệt hại nào phát sinh từ
        sự gián đoạn này.
      </p>

      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        6.3. Miễn Trừ về Mất Mát Dữ Liệu:
      </h3>
      <p>
        Bạn có trách nhiệm tự lưu trữ bản gốc Dữ Liệu Đầu Vào của mình. Chúng
        tôi không chịu trách nhiệm cho bất kỳ mất mát Dữ Liệu Người Dùng nào
        trong quá trình sử dụng.
      </p>

      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        6.4. Giới Hạn Trách Nhiệm Tối Đa:
      </h3>
      <p>
        Trong mọi trường hợp, nếu phát sinh trách nhiệm pháp lý của Dịch Vụ
        Chuyển Âm Website phải bồi thường, tổng mức bồi thường tối đa sẽ không
        vượt quá tổng số tiền phí Dịch Vụ mà bạn đã thanh toán cho chúng tôi
        trong vòng ba (03) tháng gần nhất tính đến thời điểm phát sinh khiếu
        nại.
      </p>

      <h2 className="mb-2 mt-6 text-xl font-bold text-gray-800">
        Điều 7: Bảo Mật và Quyền Sở Hữu Trí Tuệ
      </h2>
      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        7.1. Bảo Mật Thông Tin:
      </h3>
      <p>
        Chúng tôi cam kết áp dụng các biện pháp kỹ thuật và an ninh cần thiết để
        bảo vệ Dữ Liệu Người Dùng. Việc thu thập và sử dụng thông tin cá nhân
        của bạn tuân thủ theo “Chính Sách Bảo Mật” được công bố riêng.
      </p>

      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        7.2. Quyền Sở Hữu Nội dung của Người Dùng:
      </h3>
      <p>
        Bạn duy trì toàn bộ quyền sở hữu trí tuệ đối với Dữ Liệu Đầu Vào và có
        quyền sở hữu toàn bộ với Văn Bản Đầu Ra của mình. Bằng tài liệu này,
        chúng tôi chuyển giao cho bạn tất cả các quyền, quyền sở hữu và lợi ích
        của chúng tôi (nếu có) đối với Thông tin đầu ra và không yêu cầu quyền
        đồng sở hữu các thông tin này.
      </p>

      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        7.3. Giấy Phép Cấp cho Chúng Tôi:
      </h3>
      <p>
        Bằng việc tải Dữ Liệu Đầu Vào lên hệ thống, bạn cấp cho chúng tôi một
        giấy phép có giới hạn, không độc quyền, miễn phí bản quyền trên toàn cầu
        để lưu trữ, sao chép, xử lý và truyền tải dữ liệu đó,{" "}
        <strong>chỉ duy nhất</strong> cho mục đích cung cấp và cải tiến Dịch Vụ
        cho bạn. Giấy phép này sẽ tự động chấm dứt khi bạn xóa dữ liệu khỏi hệ
        thống.
      </p>

      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        7.4. Quyền Sở Hữu của Chúng Tôi:
      </h3>
      <p>
        Toàn bộ nền tảng, phần mềm, giao diện, thương hiệu, logo và các tài sản
        trí tuệ khác liên quan đến Dịch Vụ là tài sản độc quyền của Dịch Vụ
        Chuyển Âm Website.
      </p>

      <h2 className="mb-2 mt-6 text-xl font-bold text-gray-800">
        Điều 8: Xử Lý Vi Phạm và Chấm Dứt Dịch Vụ
      </h2>
      <p>
        Nếu bạn vi phạm bất kỳ điều khoản nào trong Thỏa ước này, chúng tôi có
        toàn quyền, tùy theo mức độ vi phạm, áp dụng các biện pháp từ cảnh cáo,
        tạm ngưng cho đến chấm dứt vĩnh viễn quyền truy cập Tài Khoản của bạn mà
        không cần báo trước.
      </p>
      <p>
        Trong trường hợp chấm dứt do vi phạm từ phía bạn, mọi khoản phí đã thanh
        toán sẽ <strong>không được hoàn lại</strong>. Chúng tôi cũng bảo lưu
        quyền áp dụng các biện pháp pháp lý cần thiết để bảo vệ quyền lợi của
        mình.
      </p>

      <h2 className="mb-2 mt-6 text-xl font-bold text-gray-800">
        Điều 9: Luật Áp Dụng và Giải Quyết Tranh Chấp
      </h2>
      <p>
        Điều Khoản này được điều chỉnh và giải thích theo pháp luật của nước
        Cộng hòa Xã hội Chủ nghĩa Việt Nam.
      </p>
      <p>
        Mọi tranh chấp, khiếu nại phát sinh từ hoặc liên quan đến việc sử dụng
        Dịch Vụ sẽ được ưu tiên giải quyết thông qua thương lượng, hòa giải. Nếu
        không thể giải quyết, vụ việc sẽ được đưa ra Tòa án Nhân dân có thẩm
        quyền tại Thành phố Hồ Chí Minh để giải quyết.
      </p>

      <h2 className="mb-2 mt-6 text-xl font-bold text-gray-800">
        Điều 10: Điều Khoản Chung
      </h2>
      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        10.1. Tính Hiệu Lực Từng Phần:
      </h3>
      <p>
        Nếu bất kỳ điều khoản nào của Thỏa ước này bị Tòa án có thẩm quyền tuyên
        là vô hiệu, điều khoản đó sẽ được loại bỏ mà không ảnh hưởng đến hiệu
        lực của các điều khoản còn lại.
      </p>

      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        10.2. Chuyển giao quyền và nghĩa vụ
      </h3>
      <p>
        Bạn không được phép chuyển nhượng hoặc chuyển giao bất kỳ quyền hoặc
        nghĩa vụ nào phát sinh từ Điều khoản này. Mọi nỗ lực chuyển giao như vậy
        đều vô hiệu lực. Ngược lại, chúng tôi có quyền tự do chuyển giao quyền
        và nghĩa vụ của mình cho bất kỳ chi nhánh, công ty con hoặc người kế
        thừa nào nhằm phục vụ mục tiêu kinh doanh liên quan đến Dịch vụ.
      </p>

      <h3 className="mb-1 mt-4 text-lg font-bold text-gray-700">
        10.3. Sửa Đổi, Bổ Sung:
      </h3>
      <p>
        Chúng tôi liên tục cập nhật và cải tiến Dịch vụ. Có thể chúng tôi sẽ
        chỉnh sửa các Điều khoản hoặc Dịch vụ vì các lý do như:
      </p>
      <ul>
        <li>Thay đổi yêu cầu pháp lý hoặc quy định;</li>
        <li>Yêu cầu an ninh hoặc an toàn;</li>
        <li>Những sự kiện ngoài tầm kiểm soát hợp lý của chúng tôi;</li>
        <li>Tối ưu hóa, nâng cấp trong quá trình phát triển;</li>
        <li>Thích ứng với công nghệ mới.</li>
      </ul>
      <p>
        Trong trường hợp các thay đổi này có{" "}
        <strong>tác động nghiêm trọng ảnh hưởng lợi ích</strong> của bạn, chúng
        tôi sẽ thông báo ít nhất 30 ngày trước qua email hoặc thông báo trong
        sản phẩm. Các thay đổi khác sẽ có hiệu lực ngay lập tức khi được đăng
        tải trên website. Việc bạn tiếp tục sử dụng Dịch Vụ sau khi thay đổi có
        hiệu lực đồng nghĩa với việc bạn chấp nhận hoàn toàn các nội dung sửa
        đổi đó.
      </p>

      <div class="footer">
        <p>Thỏa thuận này có hiệu lực từ ngày 05 tháng 09 năm 2025.</p>
        <p>
          © 2025 Công ty Cổ Phần Tổ Chức Phát Triển Vì Việt Nam. Đã đăng ký bản
          quyền.
        </p>
      </div>
    </div>
  );
};
export default PageTerm;
